/** @format */

import React from "react";
import { useNavigate } from "react-router-dom";
import profileImage from "../assets/images/profile_picture.png";
import Styles from "./Home.module.css";

const Home = () => {
  const navigate = useNavigate();
  const onResumeHandler = () => {
    const url = "https://drive.google.com/file/d/18QIDhNEWH59IeO5j220xwFJw2w6ll1ZY/view?usp=sharing";
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const onProjectsHandler = () => {
    navigate("/projects");
  };

  return (
    <div className={Styles.profileWrapper}>
      <div className={Styles.profile}>
        <div className={Styles.profileImage}>
          <img src={profileImage} alt="Loading..." loading="lazy" />
        </div>
        <div className={Styles.description}>
          <h1>Hey, I'm Prince Jha.</h1>
          <h3>I build Apps for Web and Mobile.</h3>
          <div className={Styles.buttonSection}>
            <button className={Styles.button} onClick={onResumeHandler}>
              Resume
            </button>
            <button className={Styles.button} onClick={onProjectsHandler}>
              Projects
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
